import React from 'react';
import CustomRedirect from "../../../../components/templateRedirects/customRedirect";
import NewYear2022 from "../../../../components/templateLandings/happy_hockey";

const HappyHockey = ({ location }) => (
  <CustomRedirect
    landingTemplate={
      <NewYear2022
        location={location}
        lang='ru'
        landingName='happy_hockey'
      />
    }
  />
)

export default HappyHockey;